import React from "react";

interface Props {
  isActive: boolean;
}

export default function DashboardIcon({ isActive }: Props) {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.24 0H3.34C1.15 0 0 1.15 0 3.33V5.23C0 7.41 1.15 8.56 3.33 8.56H5.23C7.41 8.56 8.56 7.41 8.56 5.23V3.33C8.57 1.15 7.42 0 5.24 0Z"
        fill={isActive ? "#5E9918" : "#B3B3B3"}
      />
      <path
        opacity="0.6"
        d="M16.6714 0H14.7714C12.5914 0 11.4414 1.15 11.4414 3.33V5.23C11.4414 7.41 12.5914 8.56 14.7714 8.56H16.6714C18.8514 8.56 20.0014 7.41 20.0014 5.23V3.33C20.0014 1.15 18.8514 0 16.6714 0Z"
        fill={isActive ? "#9DCD5A" : "#B3B3B3"}
      />
      <path
        d="M16.6714 11.4297H14.7714C12.5914 11.4297 11.4414 12.5797 11.4414 14.7597V16.6597C11.4414 18.8397 12.5914 19.9897 14.7714 19.9897H16.6714C18.8514 19.9897 20.0014 18.8397 20.0014 16.6597V14.7597C20.0014 12.5797 18.8514 11.4297 16.6714 11.4297V11.4297Z"
        fill={isActive ? "#5E9918" : "#B3B3B3"}
      />
      <path
        opacity="0.6"
        d="M5.24 11.4297H3.34C1.15 11.4297 0 12.5797 0 14.7597V16.6597C0 18.8497 1.15 19.9997 3.33 19.9997H5.23C7.41 19.9997 8.56 18.8497 8.56 16.6697V14.7697C8.57 12.5797 7.42 11.4297 5.24 11.4297V11.4297Z"
        fill={isActive ? "#9DCD5A" : "#B3B3B3"}
      />
    </svg>
  );
}
